"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.find = exports.filter = void 0;
/**
 * A generator version of Array.prototype.filter, with configurable maximum length.
 *
 * @param iterable The thing to loop over.
 * @param predicate The function that decides which elements to yield.
 * @param maxLength The maximum number of elements to yield.
 */
function* filter(iterable, predicate, maxLength = -1) {
    let count = 0;
    for (const x of iterable) {
        if (predicate(x)) {
            if (maxLength > -1 && count >= maxLength) {
                return;
            }
            yield x;
            count++;
        }
    }
}
exports.filter = filter;
/**
 * A version of Array.prototype.find that works on iterables.
 *
 * @param iterable The thing to loop over.
 * @param predicate The function that decides whether an element is the one we are looking for.
 */
function find(iterable, predicate) {
    for (const element of iterable) {
        if (predicate(element)) {
            return element;
        }
    }
}
exports.find = find;
